export default __webpack_public_path__ + "static/media/gw7.0c0717bc.webp";